import { render, staticRenderFns } from "./GradeAlignmentView.vue?vue&type=template&id=1c8f5e48&scoped=true"
import script from "./GradeAlignmentView.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeAlignmentView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GradeAlignmentView.vue?vue&type=style&index=0&id=1c8f5e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f5e48",
  null
  
)

export default component.exports